import { Query } from '@datorama/akita';
import { SessionState, SessionStore } from './session.store';
import { Injectable } from '@angular/core';

export function isAdminUser(userInfo?: { roles?: string[] } | null): boolean {
	return !!userInfo?.roles?.includes('ADMIN');
}

@Injectable({
	providedIn: 'root'
})
export class SessionQuery extends Query<SessionState> {
	isAuthenticated$ = this.select(state => state.isAuthenticated);
	userInfo$ = this.select(state => state.userInfo);

	constructor(protected store: SessionStore) {
		super(store);
	}
}
